import React, { useEffect, useState, useRef } from 'react';
import Sidebar from '../Components/Sidebar';
import Header from '../Components/Header';
import 'swiper/css';
import { useNavigate } from 'react-router-dom';
import Hls from "hls.js";

export default function Home() {
    const navigate = useNavigate();
    const videoRef = useRef(null);

    const [channelData, setChannelData] = useState([]);
    const [data, setData] = useState([]);
    const [videoUrl, setVideoUrl] = useState("");
    const [showVideo, setShowVideo] = useState(false);

    useEffect(() => {
        const sessiondata = JSON.parse(sessionStorage.getItem('av_data'));
        const sessiondataChannel = JSON.parse(sessionStorage.getItem('av_data_live_channels'));

        if (sessiondata) {
            setData(sessiondata);
        } else {
            fetch('https://apiv2.mobileartsme.com/av_getcontent?apisource=1&phonenumber=96170932819&ispremium=true&language=en&country=LB')
                .then(res => res.json())
                .then(data => {
                    setData(data.Content[0].Videos);
                    sessionStorage.setItem('av_data', JSON.stringify(data.Content[0].Videos));
                });
        }

        if (sessiondataChannel) {
            setChannelData(sessiondataChannel);
        } else {
            fetch('https://apiv2.mobileartsme.com/av_tvchannels')
                .then(res => res.json())
                .then(data => {
                    setChannelData(data.Channels);
                    sessionStorage.setItem('av_data_live_channels', JSON.stringify(data.Channels));
                });
        }
    }, []);

    function showLiveChannel(url) {
        setVideoUrl(url);
        setShowVideo(true);
    }

    useEffect(() => {
        let hls;

        if (videoUrl && videoRef.current) {
            if (Hls.isSupported()) {
                hls = new Hls();
                hls.loadSource(videoUrl);
                hls.attachMedia(videoRef.current);
                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    videoRef.current.play().catch((err) => console.error("AutoPlay Error:", err));
                });
            } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
                videoRef.current.src = videoUrl;
                videoRef.current.play().catch((err) => console.error("AutoPlay Error:", err));
            } else {
                console.error("HLS format is not supported in this browser.");
            }
        }

        return () => {
            if (hls) {
                hls.destroy();
            }
        };
    }, [videoUrl]);










    return (
        <div>
            <Sidebar data={data} />
            <div className="mt-3 main-body">
                <div className="container">
                    <Header />

                    <div data-aos="zoom-in" className="my-5">
                        <h1 className="bold pt-4">Live <span className="spangreen">Channels</span></h1>
                        <p>Discover movie news, trailers, fresh daily content, live streaming, and other videos in different languages</p>
                    </div>

                    {showVideo && (
                        <div style={{ position: "relative", width: "100%", marginBottom: "2rem" }}>
                            <video
                                ref={videoRef}
                                autoPlay
                                controls
                                className="w-100"
                                style={{ width: "100%" }}
                              
                            />

                            {/* LIVE Label */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "10px",
                                    left: "10px",
                                    backgroundColor: "#e35353",
                                    color: "white",
                                    padding: "4px 10px",
                                    fontWeight: "bold",
                                    borderRadius: "4px",
                                    fontSize: "14px",

                                }} >
                                Live
                            </div>

                        </div>
                    )}


                    <div className="grid-container">
                        {channelData.map((channel, index) => (
                            <div
                                key={index}
                                onClick={() => showLiveChannel(channel.ChannelURL)}
                                data-aos="zoom-in"
                                className="live-channel d-flex flex-column align-items-center justify-content-center"
                                style={{ cursor: "pointer" }}
                            >
                                <img style={{ width: '12rem' }} src={channel.ChannelThumbnail} alt={channel.ChannelName} />
                                <h5>{channel.ChannelName}</h5>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
